<template>
<div class="form_layout">
	<div class="form_outer" style="width: 800px;">
		<div class="dialog_form_head">
			增加新用户
		</div>
		<div class="dialog_form">
      <el-form :model="user" :rules="rules" ref="ruleForm" class="demo-ruleForm">
			<div class="d_content">
				<table border="0" cellspacing="0" cellpadding="0" class="table" >
					<tr>
						<td class="td_bg" width="90px">用户名 <span style="color: red;font-weight: bold">*</span></td>
						<td>
              <el-form-item  prop="username">
							<el-input v-model="username"></el-input>
              </el-form-item>
						</td>
					</tr>
          <tr>
            <td class="td_bg" width="90px">使用人姓名 <span style="color: red;font-weight: bold">*</span></td>
            <td>
              <el-form-item  prop="nickname">
                <el-input v-model="nickname"></el-input>
              </el-form-item>
            </td>
          </tr>

					<tr>
						<td class="td_bg">部门</td>
						<td>
							<el-input v-model="dept"></el-input>
						</td>
					</tr>
					<tr>
						<td class="td_bg">手机号</td>
						<td>
							<el-input v-model="mobile"></el-input>
						</td>
					</tr>
					<tr>
						<td class="td_bg">邮箱</td>
						<td>
							<el-input v-model="user_email"></el-input>
						</td>
					</tr>
					<tr>
						<td class="td_bg">权限</td>
						<td>
							<el-checkbox-group v-model="checkList">
							    <el-checkbox label="1">数据调查</el-checkbox>
							    <el-checkbox label="2">申报项目</el-checkbox>
							    <el-checkbox label="3">我有诉求</el-checkbox>
							    <el-checkbox label="4">企业走访</el-checkbox>
							</el-checkbox-group>
						</td>
					</tr>
				</table>
			</div>
      </el-form>
			  <div  class="footer_btn">
			    <el-button type="primary" @click="submitAdd">提 交</el-button>
			  </div>
		</div>
	</div>
</div>
</template>

<script>
	export default{
		name:'addus',
		data(){
			return {
				checkList: [],
        user:{
          username:"",
          nickname:"",
          dept:"",
          mobile:"",
          user_email:""
        }

			}
		},
		methods:{
      async submitAdd(){
        let data={
          username:this.user.username,
          dept:this.user.dept,
          mobile:this.user.mobile,
          user_email:this.user.user_email
        };
        data.role_id=this.checkList.join(",");

        let res = await this.$ajax.post(this.bUrl + 'api/portal/user/addUser',data);
        if(res.data.code==200){
          this.$emit('emitClose')
          this.$message.success(res.data.msg)
        }else {
          this.$message.error(res.data.msg)
        }

			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/form/addus.vue